import React from 'react';
import { Icon } from '@fourthwall/components';
import * as S from './styled';
export const IconButton = ({ className, height = 20, onClick, ...props }) => {
    return (React.createElement(S.Button, { className: className, onClick: onClick },
        React.createElement(Icon, { height: height, ...props })));
};
